import { apiErrorToToast, forceFileDownload } from "@/lib/utils";
import { downloadResultsFileRequest } from "@/requests/reports/download-results-file.request";
import { ApiErrorResponse } from "@/types/apis";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

export const useDownloadResultsFileMutation = () => {
  return useMutation({
    mutationFn: downloadResultsFileRequest,
    onError: (error: AxiosError<ApiErrorResponse>) => {
      apiErrorToToast(error);
    },
    onSuccess: (response) => {
      let fileName = "";

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const contentDisposition = response.headers["content-disposition"];

      if (contentDisposition) {
        const match = contentDisposition?.match(/filename="(.+?)"/);
        fileName = match ? match[1] : null;
      }

      forceFileDownload(url, fileName || "report.pdf");
    },
  });
};
